module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content-cards"
    }
  }, [_c('div', {
    staticClass: "txt-index"
  }, [_c('div', {
    staticClass: "cards"
  }, [_c('h2', [_vm._v("¡Bienvenidos!")]), _vm._v(" "), _c('p', [_vm._v("Por medio de esta página usted podrá interponer o gestionar peticiones, quejas, reclamos, felicitaciones o sugerencias, gracias por utilizar nuestros servicios.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img-index"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf7ed32c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-home.vue
// module id = 88
// module chunks = 0